module.exports = __webpack_public_path__ + "img/icon_guangxiaoer.435decb0.svg";